import React, { Fragment } from 'react';
import {
  Accordion,
  AccordionItem,
  SkeletonText,
  Link,
  InlineNotification
} from 'carbon-components-react';
import {
  DocumentAttachment16,
  Number_116 as Number116,
  Number_216 as Number216,
  Number_316 as Number316,
  Number_416 as Number416,
  Number_516 as Number516,
  Number_616 as Number616,
  Number_716 as Number716,
  Number_816 as Number816,
  Number_916 as Number916
} from '@carbon/icons-react';
import {
  DeleteAttachmentError,
  UploadingAttachment,
  UploadAttachmentError
} from './localStore/types';

const NumberIcons: React.FC<{ numbers: number }> = (props) => {
  const { numbers } = props;
  const chars = String(numbers).split('');
  return (
    <>
      {chars.map((c: string, inx: number) => {
        switch (c) {
          case '1':
            return <Number116 key={inx} />;
          case '2':
            return <Number216 key={inx} />;
          case '3':
            return <Number316 key={inx} />;
          case '4':
            return <Number416 key={inx} />;
          case '5':
            return <Number516 key={inx} />;
          case '6':
            return <Number616 key={inx} />;
          case '7':
            return <Number716 key={inx} />;
          case '8':
            return <Number816 key={inx} />;
          case '9':
            return <Number916 key={inx} />;
          default:
            return <Fragment key={inx}></Fragment>;
        }
      })}
    </>
  );
};

const DirectAttachmentList: React.FC<Props> = ({
  files,
  enquiryId,
  uploadAttachmentErrors,
  uploadingAttachments,
  deleteAttachmentErrors,
  deletingAttachments,
  onClearUploadAttachmentErrors,
  onClearDeleteAttachmentErrors,
  onViewAttachment,
  uploadFrom
}) => {
  return (
    <Accordion>
      <AccordionItem
        title={
          <div className="accordion-title">
            <div className="accordion-title-left-side">
              <div className="icon-div">
                <DocumentAttachment16 />
              </div>
              <div className="title-name">Uploaded documents</div>
            </div>
            <div className="status-div">
              <NumberIcons numbers={files.length} />
            </div>
          </div>
        }
      >
        <section className="accordion-content">
          {files.map((file: any) => {
            const error = deleteAttachmentErrors.find(
              (dae: DeleteAttachmentError) => dae.id === file.id
            );
            return (
              <Fragment key={`uploaded-file-${file.id}`}>
                {deletingAttachments.includes(file.id) ? (
                  <SkeletonText
                    key={`uploaded-file-${file.id}`}
                    className="uploaded-file-link-row"
                  />
                ) : (
                  <>
                    {error ? (
                      <InlineNotification
                        kind="error"
                        title={error.error}
                        key={`e-${file.id}`}
                        lowContrast
                        className="uploaded-file-link-row"
                        onCloseButtonClick={() =>
                          onClearDeleteAttachmentErrors(file.id)
                        }
                      />
                    ) : (
                      <Link
                        key={`uploaded-file-${file.id}`}
                        onClick={() => onViewAttachment(file.id)}
                        className="uploaded-file-link-row"
                      >
                        {file?.presentation_name}
                      </Link>
                    )}
                  </>
                )}
              </Fragment>
            );
          })}
          {uploadAttachmentErrors.map((uae: UploadAttachmentError) => {
            return uae.enquiryId === enquiryId && uploadFrom === 'enquiry' ? (
              <InlineNotification
                kind="error"
                title={uae.error}
                key={`e-${uae.uuid}`}
                lowContrast
                className="email-files-links-row"
                onCloseButtonClick={() =>
                  onClearUploadAttachmentErrors(uae.uuid)
                }
              />
            ) : (
              <Fragment key={`e-${uae.uuid}`}></Fragment>
            );
          })}
          {uploadingAttachments.map((up: UploadingAttachment) => {
            return up.enquiryId === enquiryId ? (
              <SkeletonText key={up.uuid} className="uploaded-file-link-row" />
            ) : (
              <Fragment key={up.uuid}></Fragment>
            );
          })}
        </section>
      </AccordionItem>
    </Accordion>
  );
};

type Props = {
  files: any[];
  enquiryId: number;
  uploadAttachmentErrors: UploadAttachmentError[];
  uploadingAttachments: UploadingAttachment[];
  deletingAttachments: number[];
  deleteAttachmentErrors: DeleteAttachmentError[];
  onClearDeleteAttachmentErrors: (id: number) => void;
  onClearUploadAttachmentErrors: (id: string) => void;
  onViewAttachment: (id: number) => void;
  uploadFrom?: string;
};

export default React.memo(DirectAttachmentList);
